import { Text, TextProps } from '@chakra-ui/react'
import { Format, ScalarContentNode } from '@helo/cms'
import { merge } from 'lodash'

import { ConditionalLink } from '../../components/Link/Link'
import { InlineSkeleton } from '../../components/SkeletonLoader'
import { ConditionalTooltip } from '../../components/Tooltip/Tooltip'
import { withUnicodeRouteArrow } from '../../utils/routeLabelDisplay'
import { pillStyles } from '../utils'

interface StringRendererProps {
  isLoading?: boolean
  contentNode: ScalarContentNode
}

export const StringRenderer = ({
  contentNode,
  isLoading,
}: StringRendererProps) => {
  const value = contentNode.data
  const showSkeleton = !!isLoading

  const text = Format.text(contentNode.state)(value)
  const { size, linkUrlStorage, linkUrl, _tooltip, textCase, styles } =
    contentNode.state

  const capitalizeStyles: TextProps =
    textCase === 'all'
      ? { textTransform: 'uppercase' }
      : textCase === 'word'
        ? { textTransform: 'capitalize' }
        : {}

  // Extract styles object if it exists and is an object
  const customStyles = styles && typeof styles === 'object' ? styles : {}

  return (
    <ConditionalTooltip
      isDisabled={
        showSkeleton || value === undefined || value === null || value === '-'
      }
      tooltipOptions={_tooltip as any}
    >
      <ConditionalLink
        isDisabled={
          showSkeleton || value === undefined || value === null || value === '-'
        }
        to={linkUrl as any}
        search={linkUrlStorage as any}
      >
        <Text
          size={size}
          {...(linkUrl && pillStyles)}
          {...capitalizeStyles}
          {...customStyles}
        >
          <InlineSkeleton isLoading={showSkeleton}>
            {withUnicodeRouteArrow(text)}
          </InlineSkeleton>
        </Text>
      </ConditionalLink>
    </ConditionalTooltip>
  )
}
